export default {
    slots: {
        overlay: 'fixed inset-0 bg-neutral-900/50',
        content: 'bg-white flex flex-col overflow-hidden focus:outline-none',
        header: 'py-4 border-b-0 shadow-sm',
        body: 'flex-1 overflow-auto',
        footer: 'py-6 px-8 border-t-0',
        close: 'absolute top-4 end-4 z-10',
    },
    variants: {
        fullscreen: {
            true: {
                content: 'fixed inset-0 size-full max-w-none rounded-none',
                header: 'py-4 px-6 border-b-0 shadow-sm',
                body: 'flex-1 overflow-auto px-8',
                footer: 'py-6 px-8 border-t-0',
            },
        },
    },
    defaultVariants: {
        fullscreen: false,
    },
};
